










import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import UserList from "@/components/user/UserList.vue";
import UserCreateDialog from "@/components/user/UserCreateDialog.vue";
import CompanySimple from "@/models/company/CompanySimple";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {UserCreateDialog, UserList, AsiPageTitle}
})
export default class Users extends Vue {

	private createDialogOpen = false;
	private icons = Icon;

	private get company(): CompanySimple | null {
		return this.isCustomer ? this.$store.state.user.loggedInUserCompany : null;
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get isAdmin(): boolean {
		return this.$store.getters['user/isAdmin'];
	}

}
